import * as React from "react";
const SvgShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M17 22a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 14 19q0-.15.075-.7L7.05 14.2A2.97 2.97 0 0 1 5 15a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 2 12q0-1.25.875-2.125A2.9 2.9 0 0 1 5 9a2.97 2.97 0 0 1 2.05.8l7.025-4.1a1.7 1.7 0 0 1-.062-.338A5 5 0 0 1 14 5q0-1.25.875-2.125A2.9 2.9 0 0 1 17 2q1.25 0 2.125.875T20 5t-.875 2.125A2.9 2.9 0 0 1 17 8a2.97 2.97 0 0 1-2.05-.8l-7.025 4.1q.05.176.063.337Q8 11.801 8 12q0 .2-.013.363t-.062.337l7.025 4.1A2.97 2.97 0 0 1 17 16q1.25 0 2.125.875T20 19t-.875 2.125A2.9 2.9 0 0 1 17 22m0-2q.424 0 .712-.288A.97.97 0 0 0 18 19a.97.97 0 0 0-.288-.712A.97.97 0 0 0 17 18a.97.97 0 0 0-.712.288A.97.97 0 0 0 16 19q0 .424.288.712.287.288.712.288M5 13q.424 0 .713-.287A.97.97 0 0 0 6 12a.97.97 0 0 0-.287-.713A.97.97 0 0 0 5 11a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 12q0 .424.287.713Q4.576 13 5 13m12-7q.424 0 .712-.287A.97.97 0 0 0 18 5a.97.97 0 0 0-.288-.713A.97.97 0 0 0 17 4a.97.97 0 0 0-.712.287A.97.97 0 0 0 16 5q0 .424.288.713Q16.575 6 17 6"
    />
  </svg>
);
export default SvgShare;
